module.exports = __webpack_public_path__ + "img/detail_img3.487d368d.jpg";